/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { AuthService } from './app/modules/auth/services/auth.service';

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => {
    const authService = appRef.injector.get(AuthService);

    // When the browser restores this page from the back/forward cache
    // (bfcache) - e.g. the user hits Back after logout redirected them to the SSO domain
    window.addEventListener('pageshow', (event: PageTransitionEvent) => {
      if (!event.persisted) {
        return;
      }
      authService.isAuthenticatedAsync().then((isAuthenticated) => {
        if (!isAuthenticated) {
          window.location.reload();
        }
      });
    });
  })
  .catch((err) => console.error(err));
